module.exports = __webpack_public_path__ + "img/chambrechat.c2502f32.jpg";